const INITIAL_STATE = {
	menuHamburger: [],
};

export const menuHamburgerReducer = (state = INITIAL_STATE, action) => {
	return state;
};
